import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useFetch } from "../../../hooks/fetch.hook";
import CommodityReportStep1 from "./components/Step1";
import CommodityReportStep2 from "./components/Step2";
import { error, success } from "../../../helpers/toasts";
import { getScreens, getCrops, generateCommodityDetectionReport } from "./_api";
import { mergeCommodities, transformToApiPayload } from "./helpers";
import {
  SAMPLE_SCREENS,
  SAMPLE_COMMODITIES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
} from "./constants";

const CommodityReport = () => {
  const { isLoading, request } = useFetch();
  const user = useSelector(({ auth }) => auth.user) || {};
  const [currentStep, setCurrentStep] = useState(1);
  const [step1Values, setStep1Values] = useState(null);
  const [screens, setScreens] = useState([]);
  const [commodities, setCommodities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const screensData = await request(getScreens);
        if (screensData && screensData !== "success") {
          setScreens(screensData);
        } else {
          setScreens(SAMPLE_SCREENS);
        }

        const commoditiesData = await request(getCrops);
        if (commoditiesData && commoditiesData !== "success") {
          const mergedCommodities = mergeCommodities(commoditiesData);
          setCommodities(mergedCommodities);
        } else {
          setCommodities(SAMPLE_COMMODITIES);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setScreens(SAMPLE_SCREENS);
        setCommodities(SAMPLE_COMMODITIES);
        error(ERROR_MESSAGES.FETCH_ERROR);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [request]);

  const handleStep1Submit = (values) => {
    setStep1Values(values);
    setCurrentStep(2);
  };

  const handleGoBack = () => {
    setCurrentStep(1);
  };

  const handleFinalSubmit = async (combinedValues) => {
    try {
      const payload = transformToApiPayload(
        combinedValues,
        screens,
        commodities,
        user
      );

      const response = await request(generateCommodityDetectionReport, payload);

      if (response && response !== "Server error") {
        success(SUCCESS_MESSAGES.REPORT_GENERATED);
        setStep1Values(null);
        setCurrentStep(1);
      } else {
        error(ERROR_MESSAGES.REPORT_ERROR);
      }
    } catch (err) {
      console.error("Error generating report:", err);
      if (err.response && err.response.status === 403) {
        error(ERROR_MESSAGES.PERMISSION_ERROR);
      } else {
        error(ERROR_MESSAGES.REPORT_ERROR);
      }
    }
  };

  return (
    <div className="row justify-content-center mt-10">
      <div className="col-12">
        <div className="bg-white rounded py-7 px-10">
          {currentStep === 1 ? (
            <CommodityReportStep1
              onSubmit={handleStep1Submit}
              screens={screens}
              commodities={commodities}
              loading={loading}
              initialValues={step1Values}
            />
          ) : (
            <CommodityReportStep2
              prevStepValues={step1Values}
              onBack={handleGoBack}
              onSubmit={handleFinalSubmit}
              loading={isLoading}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CommodityReport;
